// src/oura/merchant/ActionRow.tsx
//
// One of the latest actions, as a row: the kind of work's icon, what we did,
// and the day. Why it matters and the evidence are in its drawer (DidDrawer),
// which the row opens. Work lists them all; Home shows the newest 3 when
// nothing needs the merchant.
//
// Only a row with something behind it opens. A plan-progress entry carries
// no reason and no evidence, so its drawer said the title again and "Done";
// in the redesign that row is plain text instead of a press that leads nowhere.

import type { ClientActivityEntry } from "@service/aeo/clientReview";
import { ListRow, WorkKindIcon } from "@oura/ui";
import { dayDate } from "../lib/oura";
import { MERCHANT_V2 } from "../merchantV2";

/** Whether the drawer would add anything to the row: a reason, or a link to open. */
export function hasActionDetail(entry: ClientActivityEntry): boolean {
    return Boolean(entry.why?.trim()) || (entry.evidence ?? []).some((e) => Boolean(e.url));
}

export function ActionRow({ entry, onOpen }: { entry: ClientActivityEntry; onOpen: () => void }) {
    const opens = !MERCHANT_V2 || hasActionDetail(entry);
    return (
        <ListRow
            data-action-id={entry.id}
            lead="icon"
            stackMeta
            // A neutral icon until the server sends the kind of work
            // (BE handoff "Activity kind, why it matters, evidence links").
            icon={<WorkKindIcon kind={entry.kind} size={14} />}
            title={entry.body}
            meta={dayDate(entry.at) ?? undefined}
            onClick={opens ? onOpen : undefined}
        />
    );
}
